"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointMetadata = exports.Breakpoint = void 0;
/**
 * String enum defining breakpoints - derived from Bootstrap4 breakpoint names.
 */
var Breakpoint;
(function (Breakpoint) {
    Breakpoint["XS"] = "xs";
    Breakpoint["SM"] = "sm";
    Breakpoint["MD"] = "md";
    Breakpoint["LG"] = "lg";
    Breakpoint["XL"] = "xl";
})(Breakpoint = exports.Breakpoint || (exports.Breakpoint = {}));
/**
 * Complete mapping of Breakpoint to minimum pixel values
 */
var BreakpointValue = (_a = {},
    _a[Breakpoint.XS] = 0,
    _a[Breakpoint.SM] = 576,
    _a[Breakpoint.MD] = 768,
    _a[Breakpoint.LG] = 992,
    _a[Breakpoint.XL] = 1200,
    _a);
/**
 * Metadata defining order of breakpoints (for cascading) as well as min and max pixel values for constructing media queries.
 */
exports.breakpointMetadata = [
    {
        name: Breakpoint.XS,
        min_inclusive: BreakpointValue[Breakpoint.XS],
        max_exclusive: BreakpointValue[Breakpoint.SM],
        index: 0,
    },
    {
        name: Breakpoint.SM,
        min_inclusive: BreakpointValue[Breakpoint.SM],
        max_exclusive: BreakpointValue[Breakpoint.MD],
        index: 1,
    },
    {
        name: Breakpoint.MD,
        min_inclusive: BreakpointValue[Breakpoint.MD],
        max_exclusive: BreakpointValue[Breakpoint.LG],
        index: 2,
    },
    {
        name: Breakpoint.LG,
        min_inclusive: BreakpointValue[Breakpoint.LG],
        max_exclusive: BreakpointValue[Breakpoint.XL],
        index: 3,
    },
    {
        name: Breakpoint.XL,
        min_inclusive: BreakpointValue[Breakpoint.XL],
        max_exclusive: Number.MAX_SAFE_INTEGER,
        index: 4,
    },
];
exports.default = Breakpoint;
